<script>
import ShareHealthVaultStarted from './share-health-vault-started.vue'
import ShareHealthVaultRecipientInfo from './share-health-vault-recipient-info.vue'
import ShareHealthVaultRecipientAuth from './share-health-vault-recipient-auth.vue'
import ShareHealthVaultend from './share-health-vault-end.vue'
import { shareHealthVaultDocuments } from '@/src/services/safehaven/ShareHealthVaultDocuments'

export default {
  components: {
    ShareHealthVaultStarted,
    ShareHealthVaultRecipientInfo,
    ShareHealthVaultRecipientAuth,
    ShareHealthVaultend,
  },
  props: {
    group: {
      type: Number,
      default: 0,
    },

    dialog: {
      type: Boolean,
      required: true,
    },
    selecteddocs: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      shareVaultConfirm: 'tab1',
      recipientInfo: {},
      duration: '',
      snackbar: false,
      snackbarMessage: '',
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },

  methods: {
    closeDialog() {
      this.$emit('update:dialog', false)
      this.recipientInfo = {}
      setTimeout(() => {
        this.selected = null
        this.shareVaultConfirm = 'tab1'
      }, 500)
    },
    setRecipientInfo(info) {
      this.recipientInfo = info
    },
    async saveandshareRecord() {
      this.recipientInfo.document_list = []
      this.selecteddocs.forEach((child) => {
        this.recipientInfo.document_list.push({
          id: child.document_id,
          name: child.document_name,
        })
      })

      try {
        const responseData = await shareHealthVaultDocuments.saveRecipientInformation(
          this.recipientInfo
        )
        if (responseData.status === 200) {
          this.shareVaultConfirm = 'tab4'
        }
      } catch (error) {
        console.warn('error:: ', error.response)
        this.snackbarMessage = error.response.data
        this.snackbar = true
      }
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-dialog
      :value="dialog"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
      persistent
      no-click-animation
      overlay-color="body"
      overlay-opacity="0.6"
      min-width="300px"
      max-width="450px"
      scrollable
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.VdialogClass"
    >
      <ShareHealthVaultStarted
        v-if="shareVaultConfirm === 'tab1'"
        @getStarted="shareVaultConfirm = 'tab2'"
        @closeDialog="closeDialog"
      ></ShareHealthVaultStarted>
      <ShareHealthVaultRecipientInfo
        v-if="shareVaultConfirm === 'tab2'"
        :recepient-data="recipientInfo"
        @closeDialog="closeDialog"
        @confirmInfo="shareVaultConfirm = 'tab3'"
        @backClick="shareVaultConfirm = 'tab1'"
        @recipientInfo="setRecipientInfo"
      ></ShareHealthVaultRecipientInfo>
      <ShareHealthVaultRecipientAuth
        v-if="shareVaultConfirm === 'tab3'"
        :recipient-info="recipientInfo"
        @closeDialog="closeDialog"
        @confirmEmail="saveandshareRecord"
        @backClick="shareVaultConfirm = 'tab2'"
      ></ShareHealthVaultRecipientAuth>
      <ShareHealthVaultend
        v-if="shareVaultConfirm === 'tab4'"
        :recipient-info="recipientInfo"
        @closeDialog="closeDialog"
        @endScreen="shareVaultConfirm === ''"
        @backClick="shareVaultConfirm = 'tab3'"
      ></ShareHealthVaultend>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ee6363" class="my-auto">mdi-close-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.fabButton {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
}

.fabButtonOffset {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
  transform: translateX(-300px);
}

.VdialogClass {
  max-height: 100%;
  border-radius: 4px !important;

  /* width */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    margin-top: 5px;
    margin-bottom: 5px;
    background: $color-theme-light-input;
    border-radius: 15px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $color-theme-light-line;
    border-radius: 15px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $color-theme-light-placehold;
  }

  &::-webkit-scrollbar-thumb:active {
    background: $color-theme-light-label;
  }
}

@media screen and (max-width: 960px) {
  .VdialogClass {
    height: 100%;
    max-height: 90% !important;
    max-height: 100% !important;
    padding-bottom: 2px;
    margin: 0;
    overflow-y: scroll !important;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
  }
}
</style>
